(function () {
var $c49663ff493fd893$export$12069fd362fa1f25 = function(el) {
    return el.getAttribute('data-taxonomy') || '';
};


var $afe0338c4e6ecac6$export$188d75d71883854a = {
    active: 'filter__element--active',
    filterAlwaysOn: 'filter--always-on',
    filterSelectFirst: 'filter--select-first'
};
var $afe0338c4e6ecac6$export$e1252723db1c541 = {
    activeFilterElement: ".".concat($afe0338c4e6ecac6$export$188d75d71883854a.active),
    filterButton: '.filter__element',
    filterNavigation: '.filter',
    filterSelect: 'select',
    tiles: 'div[data-cat], li[data-cat], a[data-cat]'
};
var $afe0338c4e6ecac6$export$a73b0ab845c3cb1d = 'mcflyFilterChange';


var $6e015f178422213a$var$hideElement = function(el) {
    return el.hidden = true;
};
var $6e015f178422213a$var$showElement = function(el) {
    return el.hidden = false;
};
var $6e015f178422213a$var$storeFilterValue = function(filterNavigation, filterValue) {
    var url = new URL(window.location);
    var filterTaxonomy = (0, $c49663ff493fd893$export$12069fd362fa1f25)(filterNavigation);
    if (!filterTaxonomy) return;
    var queryParam = "filter_".concat(filterTaxonomy);
    if (filterValue) url.searchParams.set(queryParam, filterValue);
    else url.searchParams.delete(queryParam);
    try {
        window.history.replaceState(null, '', url);
    } catch (err) {
        console.error('Failed to update history state:', err);
    }
};
var $6e015f178422213a$export$6002050ff15b8b96 = function(e) {
    var filterNavigation = e.target.closest((0, $afe0338c4e6ecac6$export$e1252723db1c541).filterNavigation);
    // Add a hash to the URL to allow direct linking to a specific category if a real user interaction is detected.
    if (e.isTrusted) $6e015f178422213a$var$storeFilterValue(filterNavigation, e.target.value);
    // Dispatch the filter change event
    filterNavigation.dispatchEvent(new CustomEvent((0, $afe0338c4e6ecac6$export$a73b0ab845c3cb1d), {
        detail: {
            filterValue: e.target.value
        },
        bubbles: true
    }));
};
var $6e015f178422213a$export$e6cb70c33c958e7d = function(e) {
    var _filterNavigation_querySelector;
    var target = e.currentTarget;
    var filterNavigation = target.closest((0, $afe0338c4e6ecac6$export$e1252723db1c541).filterNavigation);
    var selectedFilter = filterNavigation.querySelector((0, $afe0338c4e6ecac6$export$e1252723db1c541).activeFilterElement);
    // If the "always on" property is enabled, it should prevent the currently active filter from being disabled when the user clicks on it.
    if (filterNavigation.classList.contains((0, $afe0338c4e6ecac6$export$188d75d71883854a).filterAlwaysOn) && target === selectedFilter) return;
    if (selectedFilter && selectedFilter === target) // Clicked the item that was already selected
    target.classList.remove((0, $afe0338c4e6ecac6$export$188d75d71883854a).active);
    else {
        // Clicked another item than the selected one
        selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.classList.remove((0, $afe0338c4e6ecac6$export$188d75d71883854a).active);
        target.classList.add((0, $afe0338c4e6ecac6$export$188d75d71883854a).active);
    }
    var filterValue = ((_filterNavigation_querySelector = filterNavigation.querySelector((0, $afe0338c4e6ecac6$export$e1252723db1c541).activeFilterElement)) === null || _filterNavigation_querySelector === void 0 ? void 0 : _filterNavigation_querySelector.getAttribute('data-cat')) || '';
    // Add a hash to the URL to allow direct linking to a specific category if a real user interaction is detected.
    if (e.isTrusted) $6e015f178422213a$var$storeFilterValue(filterNavigation, filterValue);
    // Dispatch the filter change event
    filterNavigation.dispatchEvent(new CustomEvent((0, $afe0338c4e6ecac6$export$a73b0ab845c3cb1d), {
        detail: {
            filterValue: filterValue
        },
        bubbles: true
    }));
};
var $6e015f178422213a$export$466e4ac576e3445 = function(tilesContainer, filterValue) {
    if (!tilesContainer) return;
    tilesContainer.querySelectorAll((0, $afe0338c4e6ecac6$export$e1252723db1c541).tiles).forEach(function(tile) {
        // Show every tile
        $6e015f178422213a$var$showElement(tile);
        if (filterValue) {
            // Hide tile if it its categories don't contain the target category
            var tileCategories = tile.getAttribute('data-cat').split(' ');
            if (!tileCategories.includes(filterValue)) $6e015f178422213a$var$hideElement(tile);
        }
    });
};




var $b080b0fc3f5014f4$var$getDefaultFilterValue = function(el) {
    var taxonomy = (0, $c49663ff493fd893$export$12069fd362fa1f25)(el);
    if (!taxonomy) return '';
    // Check if the URL contains a search query parameter
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("filter_".concat(taxonomy)) || '';
};
var $b080b0fc3f5014f4$var$initFilterSelect = function(el) {
    var select = el.querySelector((0, $afe0338c4e6ecac6$export$e1252723db1c541).filterSelect);
    if (!select) return;
    var defaultValue = $b080b0fc3f5014f4$var$getDefaultFilterValue(el);
    if (defaultValue) {
        var targetFilterElement = el.querySelector("".concat((0, $afe0338c4e6ecac6$export$e1252723db1c541).filterSelect, ' option[value="').concat(defaultValue, '"]'));
        select.value = targetFilterElement ? defaultValue : '';
    }
    // Dispatch a change event to show the correct tiles on page load
    select.dispatchEvent(new Event('change'));
};
var $b080b0fc3f5014f4$var$initFilterButtons = function(el) {
    var _el_querySelector;
    var filterButtons = el.querySelectorAll((0, $afe0338c4e6ecac6$export$e1252723db1c541).filterButton);
    if (!filterButtons.length) return;
    var defaultValue = $b080b0fc3f5014f4$var$getDefaultFilterValue(el);
    var targetFilterElement = el.querySelector("".concat((0, $afe0338c4e6ecac6$export$e1252723db1c541).filterButton, '[data-cat="').concat(defaultValue, '"]'));
    if (defaultValue && targetFilterElement) {
        if (!targetFilterElement.classList.contains((0, $afe0338c4e6ecac6$export$188d75d71883854a).active)) targetFilterElement.click();
    } else // If one filter element is always on or the first filter element should be preselected, the first filter element is clicked.
    if ([
        (0, $afe0338c4e6ecac6$export$188d75d71883854a).filterSelectFirst,
        (0, $afe0338c4e6ecac6$export$188d75d71883854a).filterAlwaysOn
    ].some(function(className) {
        return el.classList.contains(className);
    })) (_el_querySelector = el.querySelector((0, $afe0338c4e6ecac6$export$e1252723db1c541).filterButton)) === null || _el_querySelector === void 0 ? void 0 : _el_querySelector.click();
};
var $b080b0fc3f5014f4$var$initCallback = function(el) {
    var // Mobile Control: Add the change event listener to the select element
    _el_querySelector;
    /**
	 * Add the event listeners
	 */ // Add the filter change event listener to the filter navigation element
    el.addEventListener((0, $afe0338c4e6ecac6$export$a73b0ab845c3cb1d), function(e) {
        (0, $6e015f178422213a$export$466e4ac576e3445)(el.nextElementSibling, e.detail.filterValue);
    });
    (_el_querySelector = el.querySelector((0, $afe0338c4e6ecac6$export$e1252723db1c541).filterSelect)) === null || _el_querySelector === void 0 ? void 0 : _el_querySelector.addEventListener('change', (0, $6e015f178422213a$export$6002050ff15b8b96));
    // Desktop Control: Add the click event listener to every filter button
    el.querySelectorAll((0, $afe0338c4e6ecac6$export$e1252723db1c541).filterButton).forEach(function(filterEl) {
        return filterEl.addEventListener('click', (0, $6e015f178422213a$export$e6cb70c33c958e7d));
    });
    /**
	 * Initialize the filter control elements
	 */ $b080b0fc3f5014f4$var$initFilterSelect(el);
    $b080b0fc3f5014f4$var$initFilterButtons(el);
};
document.querySelectorAll((0, $afe0338c4e6ecac6$export$e1252723db1c541).filterNavigation).forEach($b080b0fc3f5014f4$var$initCallback);

})();
//# sourceMappingURL=filter.min.js.map
